import type { RouteObject } from 'react-router-dom';

/** Bibliothèque : chaque page est un chunk chargé à la demande. */
export const libraryRoutes: RouteObject[] = [
  { path: 'bibliotheque', lazy: () => import('./CatalogPage').then((m) => ({ Component: m.CatalogPage })) },
  { path: 'bibliotheque/livre/:slug', lazy: () => import('./BookDetailPage').then((m) => ({ Component: m.BookDetailPage })) },
  { path: 'bibliotheque/ressources', lazy: () => import('./ResourcesPage').then((m) => ({ Component: m.ResourcesPage })) },
  { path: 'bibliotheque/panier', lazy: () => import('./CartPage').then((m) => ({ Component: m.CartPage })) },
  { path: 'bibliotheque/commande', lazy: () => import('./CheckoutPage').then((m) => ({ Component: m.CheckoutPage })) },
  { path: 'bibliotheque/mes-livres', lazy: () => import('./MyBooksPage').then((m) => ({ Component: m.MyBooksPage })) },
  { path: 'bibliotheque/lire/:bookId', lazy: () => import('./ReaderPage').then((m) => ({ Component: m.ReaderPage })) },
  {
    path: 'admin/bibliotheque',
    lazy: () => import('./admin/AdminLayout').then((m) => ({ Component: m.AdminLibraryGuard })),
    children: [
      { index: true, lazy: () => import('./admin/AdminBooksPage').then((m) => ({ Component: m.AdminBooksPage })) },
      { path: 'livres/nouveau', lazy: () => import('./admin/AdminBookEditPage').then((m) => ({ Component: m.AdminBookEditPage })) },
      { path: 'livres/:id', lazy: () => import('./admin/AdminBookEditPage').then((m) => ({ Component: m.AdminBookEditPage })) },
      { path: 'commandes', lazy: () => import('./admin/AdminOrdersPage').then((m) => ({ Component: m.AdminOrdersPage })) },
      { path: 'ressources', lazy: () => import('./admin/AdminResourcesPage').then((m) => ({ Component: m.AdminResourcesPage })) },
      { path: 'points-relais', lazy: () => import('./admin/AdminRelayPointsPage').then((m) => ({ Component: m.AdminRelayPointsPage })) },
    ],
  },
];
